export default __webpack_public_path__ + "static/media/cat.39a05a09.svg";